import React from "react";
import PropTypes from "prop-types";
import {AListItem, AListItemTitle} from "@cisco-sbg-ui/magna-react";
import {useDispatch} from "react-redux";
import {setIncidentStatus} from "store/features/incidentsSlice";
import {sendIncidentStatusTelemetry} from "api/telemetry/incidentsTelemetrics";
import {STATUS} from "models/options";

const BulkActionStatusMenuItems = ({incidents = [], unselectAll}) => {
  const dispatch = useDispatch();
  let disallowStatus = "";

  if (incidents.length) {
    const selectedStatuses = new Set(incidents.map((i) => i.status));
    if (selectedStatuses.size === 1) {
      [disallowStatus] = selectedStatuses;
    }
  }

  const handleBulkStatusChange = (status) => {
    const isBulkAction = true;
    sendIncidentStatusTelemetry(status, true, isBulkAction);
    dispatch(setIncidentStatus({incidents, status}));
    unselectAll();
  };

  return (
    <>
      <AListItemTitle>Change Status</AListItemTitle>
      {STATUS.map((status) => {
        const {name: displayName, value} = status;
        return (
          <AListItem
            data-testid={"BulkActonStatusMenuItems-ListItem"}
            key={`action-${value}`}
            id={`action-${value}`}
            className="bulk-action__status-list-item"
            disabled={disallowStatus === value || incidents.length === 0}
            onClick={() => handleBulkStatusChange(value)}>
            {displayName}
          </AListItem>
        );
      })}
    </>
  );
};

BulkActionStatusMenuItems.propTypes = {
  incidents: PropTypes.array,
  unselectall: PropTypes.func
};

export default BulkActionStatusMenuItems;
